// Pricing helpers — mirror backend logic
export const SHIPPING_FLAT = 12;
export const FREE_SHIPPING_THRESHOLD = 100;
export const TAX_RATE = 0.08;

export const calcShipping = (subtotalAfterDiscount, freeShipping = false) => {
  if (freeShipping || subtotalAfterDiscount >= FREE_SHIPPING_THRESHOLD) return 0;
  return SHIPPING_FLAT;
};

export const calcTax = (taxable) => Math.round(taxable * TAX_RATE * 100) / 100;

export const calcTotals = (subtotal, coupon) => {
  const discount = coupon?.valid
    ? Math.round(subtotal * (coupon.discount_percent / 100) * 100) / 100
    : 0;
  const afterDiscount = Math.max(subtotal - discount, 0);
  const shipping = calcShipping(afterDiscount, !!coupon?.free_shipping);
  const tax = calcTax(afterDiscount);
  const total = Math.round((afterDiscount + shipping + tax) * 100) / 100;
  return { subtotal, discount, shipping, tax, total };
};

export const fmt = (n) => `$${Number(n).toFixed(2)}`;
